// extracted by mini-css-extract-plugin
export default {"add-support-type-modal":"style_add-support-type-modal__hMCep","addSupportTypeModal":"style_add-support-type-modal__hMCep"};